module.exports = __webpack_public_path__ + "img/Flyer_capac_union.a073d6a6.jpg";